<template>
  <component :is="layoutComponent">
    <router-view />
  </component>
</template>

<script>
import MainLayout from "./components/layout/MainLayout.vue";

export default {
  name: "App",
  components: {
    MainLayout,
  },
  computed: {
    layoutComponent() {
      const layout = this.$route.meta?.layout;
      return ((this.$route.path === '/' || !layout || layout === 'none') && !this.$route.path.startsWith('/admin'))? 'div': 'MainLayout';
    }
  }
};
</script>

<style>
@tailwind base;
@tailwind components;
@tailwind utilities;

/* Add any global styles here */
</style>
